<template>
  <b-container fluid>
    <admin-preloader :show="loading"/>
    <admin-breadcrumb name="Payment Methods"/>
    <b-row>
      <b-col cols="12">
        <admin-panel title="Payment Method Availability" with-footer>
          <b-form-checkbox v-model="achEnabled" switch size="lg">
            Enable ACH bank accounts
          </b-form-checkbox>
          <p class="text-muted mt-2 mb-0">
            When disabled, users cannot add new ACH payment methods. Existing
            payment methods and scheduled payments are not removed.
          </p>
          <template v-slot:footer>
            <b-btn variant="primary" :disabled="saving" @click="save">
              Save Settings
              <b-spinner v-if="saving" class="ml-1" small/>
            </b-btn>
          </template>
        </admin-panel>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AdminBreadcrumb from "../components/AdminBreadcrumb.vue";
import AdminPanel from "../components/AdminPanel.vue";
import AdminPreloader from "../components/AdminPreloader.vue";
import { API_ROUTES } from "../api";

export default {
  name: "AdminPaymentMethodSettings",
  components: { AdminBreadcrumb, AdminPanel, AdminPreloader },
  data() {
    return { loading: true, saving: false, achEnabled: false };
  },
  methods: {
    load() {
      this.$api.get(API_ROUTES.ADMIN_PAYMENT_METHOD_SETTINGS)
        .then(({ data }) => { this.achEnabled = !!data.ach_enabled; })
        .finally(() => { this.loading = false; });
    },
    save() {
      this.saving = true;
      this.$api.post(API_ROUTES.ADMIN_PAYMENT_METHOD_SETTINGS, {
        ach_enabled: this.achEnabled,
      }).then(({ data }) => {
        this.achEnabled = !!data.ach_enabled;
        this.$bvToast.toast("Payment method settings saved", {
          title: "Saved",
          variant: "success",
        });
      }).catch(({ response }) => {
        this.$bvToast.toast(response?.data?.message || "Failed to save settings", {
          title: "Error",
          variant: "danger",
        });
      }).finally(() => { this.saving = false; });
    },
  },
  created() {
    this.load();
  },
};
</script>
